/**
 * List limits for data-import and voter-registration UIs (must stay within backend caps).
 */

/** Rows fetched for Admin → Data import → Job history (`GET /data-management/jobs`). */
export const DATA_IMPORT_JOB_HISTORY_LIMIT = 100;

/** Snapshot options on Voter Registration (`GET /voter-registration/snapshots`). Must stay ≤ `VOTER_SNAPSHOT_LIST_MAX` in `voterAggregatesService.js`. */
export const VOTER_REGISTRATION_SNAPSHOT_LIST_LIMIT = 100;

/** Max bars per geography tab on Voter Registration charts (district tabs show all CO districts). */
export const VOTER_REGISTRATION_GEO_CHART_LIMITS = {
  county: 35,
  state_house: 65,
  state_senate: 35,
  congressional: 8,
} as const;

export type VoterRegistrationGeoChartTabId = keyof typeof VOTER_REGISTRATION_GEO_CHART_LIMITS;
